import api from '../config/api';

export default {
  getBills: (accountId, pageNumber = 1, pageSize = 20) =>
    api.get(`api/v1/accounts/${accountId}/bills/async`, {
      page_size: pageSize,
      page: pageNumber
    }),

  getLastBill: accountId => api.get(`/api/v1/accounts/${accountId}/bills/last`),
  getCurrentBill: accountId => api.get(`api/v1/accounts/${accountId}/bills/comparison`),
  getBillProgress: accountId => api.get(`api/v1/accounts/${accountId}/bills/progress`),
  getConsumptionHistory: (accountId, periods) =>
    api.get(`api/v1/accounts/${accountId}/bills/progress`, { version: 2, periods }),
  getPrintedBill: (accountId, billId) => {
    const response = api.get(`api/v1/accounts/${accountId}/bills/${billId}/printed_bill`);
    return response;
  },

  getPrintedBillPDF: (clientNumber, billId) =>
    api.get(
      '/api/v1/bills/pdf',
      { client_number: clientNumber, external_id: billId },
      { headers: { Accept: 'application/pdf' }, responseType: 'arraybuffer' }
    ),

  getMultipleBills: clientNumber => {
    const response = api.get(`/api/v1/bills/zipped`, { client_number: clientNumber });
    return response;
  },
  getPublicPaymentDocument: (clientNumber, userData, externalId = null) =>
    api.post('api/v1/bills/payment_document', {
      client_number: clientNumber,
      email: userData.email,
      document_type: userData.documentType,
      document_number: userData.documentNumber,
      external_id: externalId
    }),
  getLastBillInformation: (clientNumber, email) =>
    api.get('api/v1/accounts/last_bill', { client_number: clientNumber, email })
};
